/* eslint-disable camelcase */
import React, { useEffect, useState, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useQuery, api } from "../../../api"

import PrintIcon from "@mui/icons-material/Print"
import CloseIcon from "@mui/icons-material/Close"
import { useReactToPrint } from "react-to-print"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(2),
  flexGrow: 1,
  padding: "0 16px",
  minHeight: "80vh",
}))

// =======================================================================
// COMPONENTE DE REPORTE PARA IMPRESIÓN (Formato A4)
// =======================================================================
const ReporteComprobanteCobro = ({ detalleCobro, ciaNombre }) => {
  if (!detalleCobro || !detalleCobro.cabecera) return null

  const { cabecera, facturas, garantias, formas_pago, postfechados_total } = detalleCobro
  const granTotal = Number(cabecera.cxcmonto || 0) + Number(postfechados_total || 0)

  const now = new Date()
  const fecImpresion = now.toLocaleDateString("es-EC", { day: "2-digit", month: "short", year: "numeric" })
  const horaImpresion = now.toLocaleTimeString("es-EC", { hour12: false })

  return (
    <div style={{ padding: "40px", fontFamily: "Arial, sans-serif", color: "#000", backgroundColor: "#fff" }}>
      {/* ENCABEZADO */}
      <div style={{ textAlign: "center", marginBottom: "20px", borderBottom: "2px solid #000", paddingBottom: "10px" }}>
        <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "bold", textTransform: "uppercase" }}>{ciaNombre}</h2>
        <h3 style={{ margin: "5px 0", fontSize: "18px" }}>COMPROBANTE DE COBRO</h3>
        <h4 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }}>No. {cabecera.cxcnumcomp}</h4>
      </div>

      {/* DATOS GENERALES */}
      <table style={{ width: "100%", fontSize: "12px", marginBottom: "20px" }}>
        <tbody>
          <tr>
            <td style={{ width: "15%", fontWeight: "bold", paddingBottom: "4px" }}>Cliente</td>
            <td style={{ width: "45%", paddingBottom: "4px" }}>
              | {cabecera.clicodigo} - {cabecera.clinombre}
            </td>
            <td style={{ width: "15%", fontWeight: "bold", paddingBottom: "4px" }}>Fecha Emisión</td>
            <td style={{ width: "25%", paddingBottom: "4px" }}>| {cabecera.cxcfecemi}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>R.U.C.</td>
            <td style={{ paddingBottom: "4px" }}>| {cabecera.cliruc}</td>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Estado</td>
            <td style={{ paddingBottom: "4px" }}>
              | {cabecera.cxcstatus === "C" ? "PROCESADO" : cabecera.cxcstatus === "A" ? "ANULADO" : cabecera.cxcstatus}
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Recaudador</td>
            <td style={{ paddingBottom: "4px" }}>
              | {cabecera.reccodigo} - {cabecera.recnombre}
            </td>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Origen</td>
            <td style={{ paddingBottom: "4px" }}>| {cabecera.cxcorigen}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Caja</td>
            <td style={{ paddingBottom: "4px" }}>
              | {cabecera.cjacodigo} - {cabecera.cjadescri}
            </td>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Usuario Sis.</td>
            <td style={{ paddingBottom: "4px" }}>| {cabecera.cxcusrisys}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", paddingBottom: "4px" }}>Concepto</td>
            <td colSpan="3" style={{ paddingBottom: "4px" }}>
              | {cabecera.cxcdetalle}
            </td>
          </tr>
        </tbody>
      </table>

      {/* FACTURAS APLICADAS */}
      {facturas && facturas.length > 0 && (
        <div style={{ marginBottom: "20px" }}>
          <div style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "5px", borderBottom: "1px solid #000" }}>
            Facturas Aplicadas
          </div>
          <table style={{ width: "100%", fontSize: "11px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc" }}>
                <th style={{ textAlign: "left", padding: "4px" }}>Factura</th>
                <th style={{ textAlign: "center", padding: "4px" }}>Cuota</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Saldo Anterior</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Valor Aplicado</th>
                <th style={{ textAlign: "center", padding: "4px" }}>N/D</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: "1px dashed #eee" }}>
                  <td style={{ padding: "4px" }}>{item.facnumfac}</td>
                  <td style={{ textAlign: "center", padding: "4px" }}>{item.facsecuen}</td>
                  <td style={{ textAlign: "right", padding: "4px" }}>${Number(item.facsaldo).toFixed(2)}</td>
                  <td style={{ textAlign: "right", padding: "4px", fontWeight: "bold" }}>
                    ${Number(item.cxcabono).toFixed(2)}
                  </td>
                  <td style={{ textAlign: "center", padding: "4px" }}>{item.cxcndfac || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* GARANTÍAS APLICADAS */}
      {garantias && garantias.length > 0 && (
        <div style={{ marginBottom: "20px" }}>
          <div style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "5px", borderBottom: "1px solid #000" }}>
            Documentos en Garantía
          </div>
          <table style={{ width: "100%", fontSize: "11px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc" }}>
                <th style={{ textAlign: "left", padding: "4px" }}>Factura</th>
                <th style={{ textAlign: "center", padding: "4px" }}>Cuota</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Saldo Garantizado</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Valor Aplicado</th>
              </tr>
            </thead>
            <tbody>
              {garantias.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: "1px dashed #eee" }}>
                  <td style={{ padding: "4px" }}>{item.facnumfac}</td>
                  <td style={{ textAlign: "center", padding: "4px" }}>{item.facsecuen}</td>
                  <td style={{ textAlign: "right", padding: "4px" }}>${Number(item.facsaldo).toFixed(2)}</td>
                  <td style={{ textAlign: "right", padding: "4px", fontWeight: "bold" }}>
                    ${Number(item.cxcabono).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* FORMAS DE PAGO */}
      {formas_pago && formas_pago.length > 0 && (
        <div style={{ marginBottom: "20px" }}>
          <div style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "5px", borderBottom: "1px solid #000" }}>
            Formas de Pago / Recaudo
          </div>
          <table style={{ width: "100%", fontSize: "11px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc" }}>
                <th style={{ textAlign: "left", padding: "4px" }}>Tipo Pago</th>
                <th style={{ textAlign: "left", padding: "4px" }}>Banco</th>
                <th style={{ textAlign: "left", padding: "4px" }}>Cta / Tarjeta</th>
                <th style={{ textAlign: "left", padding: "4px" }}>Ref / Cheque</th>
                <th style={{ textAlign: "right", padding: "4px" }}>Valor Ingresado</th>
              </tr>
            </thead>
            <tbody>
              {formas_pago.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: "1px dashed #eee" }}>
                  <td style={{ padding: "4px" }}>{item.cxctippag}</td>
                  <td style={{ padding: "4px" }}>{item.bcodescri || item.bcocodigo || "N/A"}</td>
                  <td style={{ padding: "4px" }}>{item.cxcctacte || "N/A"}</td>
                  <td style={{ padding: "4px" }}>{item.cxcnumche || "N/A"}</td>
                  <td style={{ textAlign: "right", padding: "4px", fontWeight: "bold" }}>
                    ${Number(item.cxcmonto || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* TOTALES */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
        <table style={{ width: "40%", fontSize: "12px" }}>
          <tbody>
            {postfechados_total > 0 && (
              <tr>
                <td style={{ padding: "4px 0" }}>Chq. Postfechados:</td>
                <td style={{ textAlign: "right", padding: "4px 0" }}>${Number(postfechados_total).toFixed(2)}</td>
              </tr>
            )}
            <tr>
              <td style={{ padding: "4px 0", fontWeight: "bold" }}>Valor Cobrado:</td>
              <td style={{ textAlign: "right", padding: "4px 0", fontWeight: "bold" }}>
                ${Number(cabecera.cxcmonto || 0).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td colSpan="2" style={{ borderBottom: "1px solid #000" }}></td>
            </tr>
            <tr>
              <td style={{ padding: "8px 0", fontWeight: "bold", fontSize: "14px" }}>TOTAL GENERAL:</td>
              <td style={{ textAlign: "right", padding: "8px 0", fontWeight: "bold", fontSize: "14px" }}>
                ${granTotal.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* METADATA INFERIOR */}
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "10px", marginTop: "40px" }}>
        <div>Doc. Interno - SIAC Web</div>
        <div>
          <span style={{ marginRight: "20px" }}>Impreso: {fecImpresion}</span>
          <span>Hora: {horaImpresion}</span>
        </div>
      </div>

      {/* FIRMAS */}
      <table style={{ width: "100%", fontSize: "11px", textAlign: "center", marginTop: "60px" }}>
        <tbody>
          <tr>
            <td style={{ width: "33%" }}>
              <div style={{ borderTop: "1px solid #000", margin: "0 40px", paddingTop: "5px" }}>ENTREGADO POR</div>
            </td>
            <td style={{ width: "33%" }}>
              <div style={{ borderTop: "1px solid #000", margin: "0 40px", paddingTop: "5px" }}>REVISADO POR</div>
            </td>
            <td style={{ width: "33%" }}>
              <div style={{ borderTop: "1px solid #000", margin: "0 40px", paddingTop: "5px" }}>RECIBÍ CONFORME</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const CobrosDetalleIndex = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const cxcnumcomp = location.state?.cxcnumcomp

  // Estados para el modal de vista previa e impresión
  const [modalImpresionOpen, setModalImpresionOpen] = useState(false)
  const componentRef = useRef()

  // Extracción del nombre de la compañía desde el JWT local
  let ciaNombreActual = "EMPRESA S.A."
  try {
    const jwtDataStr = localStorage.getItem("jwt")
    if (jwtDataStr) {
      const jwtData = JSON.parse(jwtDataStr)
      ciaNombreActual = jwtData?.seleccion?.cliciacianombre || "EMPRESA S.A."
    }
  } catch (error) {
    console.error("Error al leer datos de la compañía:", error)
  }

  useEffect(() => {
    if (!cxcnumcomp) {
      navigate(-1)
    }
  }, [cxcnumcomp, navigate])

  const { data: detalleCobro, isLoading } = useQuery({
    queryKey: ["getDetalleCobro", cxcnumcomp],
    queryFn: async () => {
      try {
        const response = await api.post("/ConsultasCobrosAplA/getDetalleCobro", { cxcnumcomp })

        const resData = response?.data
        if (resData?.data?.data?.cabecera) return resData.data.data
        if (resData?.data?.cabecera) return resData.data
        if (resData?.cabecera) return resData

        return null
      } catch (error) {
        console.error("Error al obtener detalle del cobro:", error)
        return null
      }
    },
    enabled: !!cxcnumcomp,
    refetchOnWindowFocus: false,
  })

  // Lógica de Impresión nativa
  const handlePrintAction = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Comprobante_${cxcnumcomp}`,
  })

  if (!detalleCobro) return <CustomBackdrop isLoading={isLoading} />

  const { cabecera, facturas, postfechados_total, garantias, formas_pago } = detalleCobro
  const granTotal = Number(cabecera?.cxcmonto || 0) + Number(postfechados_total || 0)

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, px: 3 }}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            Detalle del Cobro: {cxcnumcomp}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
            onClick={() => setModalImpresionOpen(true)}
            sx={{ fontWeight: "bold" }}
          >
            Imprimir Comprobante
          </Button>
        </Box>

        <CustomBackdrop isLoading={isLoading} />

        <StyledRoot>
          {/* BLOQUE 1: DATOS DE CABECERA */}
          <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary" gutterBottom>
              Información General del Documento
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <TextField fullWidth disabled size="small" label="Comprobante" value={cabecera?.cxcnumcomp || ""} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField fullWidth disabled size="small" label="Fecha Emisión" value={cabecera?.cxcfecemi || ""} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  disabled
                  size="small"
                  label="Origen / Naturaleza"
                  value={cabecera?.cxcorigen || ""}
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <TextField fullWidth disabled size="small" label="Cód. Cliente" value={cabecera?.clicodigo || ""} />
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  fullWidth
                  disabled
                  size="small"
                  label="Razón Social / Nombre"
                  value={cabecera?.clinombre || ""}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField fullWidth disabled size="small" label="R.U.C." value={cabecera?.cliruc || ""} />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  disabled
                  size="small"
                  label="Recaudador"
                  value={`${cabecera?.reccodigo || ""} - ${cabecera?.recnombre || ""}`}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField fullWidth disabled size="small" label="Observaciones" value={cabecera?.cxcdetalle || ""} />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", gap: 3, mt: 1, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                  <Typography variant="body2">
                    <b>Estado:</b>{" "}
                    {cabecera?.cxcstatus === "C"
                      ? "PROCESADO"
                      : cabecera?.cxcstatus === "A"
                        ? "ANULADO"
                        : cabecera?.cxcstatus}
                  </Typography>
                  <Typography variant="body2">
                    <b>Usuario Sistema:</b> {cabecera?.cxcusrisys}
                  </Typography>
                  <Typography variant="body2">
                    <b>Fecha/Hora Sis:</b> {cabecera?.cxcfecisys} {cabecera?.cxchorisys}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* BLOQUE 2: DISTRIBUCIÓN DEL COBRO */}
          <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary" gutterBottom>
              Aplicación y Distribución del Cobro
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {facturas && facturas.length > 0 && (
              <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#424242" }}>
                  Facturas Aplicadas (Cobro Normal)
                </Typography>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#e0f7fa" }}>
                      <TableRow>
                        <TableCell>
                          <b>Factura</b>
                        </TableCell>
                        <TableCell align="center">
                          <b>Cuota</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Saldo Anterior</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Valor Aplicado (Abono)</b>
                        </TableCell>
                        <TableCell align="center">
                          <b>N/D Factura</b>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {facturas.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.facnumfac}</TableCell>
                          <TableCell align="center">{row.facsecuen}</TableCell>
                          <TableCell align="right">${Number(row.facsaldo).toFixed(2)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "primary.main" }}>
                            ${Number(row.cxcabono).toFixed(2)}
                          </TableCell>
                          <TableCell align="center">{row.cxcndfac || "N/A"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {garantias && garantias.length > 0 && (
              <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#2E7D32" }}>
                  Documentos en Garantía Aplicados
                </Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ border: "1px solid #81c784" }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#e8f5e9" }}>
                      <TableRow>
                        <TableCell>
                          <b>Factura</b>
                        </TableCell>
                        <TableCell align="center">
                          <b>Cuota</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Saldo Garantizado</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Valor Aplicado</b>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {garantias.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.facnumfac}</TableCell>
                          <TableCell align="center">{row.facsecuen}</TableCell>
                          <TableCell align="right">${Number(row.facsaldo).toFixed(2)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#2E7D32" }}>
                            ${Number(row.cxcabono).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* BLOQUE 3: FORMAS DE PAGO */}
            {formas_pago && formas_pago.length > 0 && (
              <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold", color: "#1565c0" }}>
                  Formas de Pago / Recaudo
                </Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ border: "1px solid #90caf9" }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: "#e3f2fd" }}>
                      <TableRow>
                        <TableCell>
                          <b>Tipo de Pago</b>
                        </TableCell>
                        <TableCell>
                          <b>Banco</b>
                        </TableCell>
                        <TableCell>
                          <b>Cuenta / Tarjeta</b>
                        </TableCell>
                        <TableCell>
                          <b>No. Referencia / Cheque</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>Valor Ingresado</b>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formas_pago.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.cxctippag}</TableCell>
                          <TableCell>{row.bcodescri || row.bcocodigo || "N/A"}</TableCell>
                          <TableCell>{row.cxcctacte || "N/A"}</TableCell>
                          <TableCell>{row.cxcnumche || "N/A"}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#1565c0" }}>
                            ${Number(row.cxcmonto || 0).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* RESUMEN DE TOTALES */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Paper elevation={0} sx={{ p: 2, bgcolor: "#f5f5f5", minWidth: "300px", border: "1px solid #e0e0e0" }}>
                <Grid container spacing={1}>
                  {postfechados_total > 0 && (
                    <>
                      <Grid item xs={7}>
                        <Typography variant="body2">Chq. Postfechados:</Typography>
                      </Grid>
                      <Grid item xs={5} align="right">
                        <Typography variant="body2">${Number(postfechados_total).toFixed(2)}</Typography>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={7}>
                    <Typography variant="body2" fontWeight="bold">
                      Valor Cobrado:
                    </Typography>
                  </Grid>
                  <Grid item xs={5} align="right">
                    <Typography variant="body2" fontWeight="bold">
                      ${Number(cabecera?.cxcmonto || 0).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider sx={{ my: 0.5 }} />
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="subtitle1" color="error" fontWeight="bold">
                      TOTAL GENERAL:
                    </Typography>
                  </Grid>
                  <Grid item xs={5} align="right">
                    <Typography variant="subtitle1" color="error" fontWeight="bold">
                      ${granTotal.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Paper>
        </StyledRoot>

        {/* MODAL DE VISTA PREVIA E IMPRESIÓN (HTML a PDF Front-end) */}
        <Dialog
          open={modalImpresionOpen}
          onClose={() => setModalImpresionOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { minHeight: "80vh", backgroundColor: "#525659" } }}
        >
          <DialogTitle
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "white" }}
          >
            <Typography variant="h6" fontWeight="bold">
              Vista Previa de Impresión
            </Typography>
            <IconButton onClick={() => setModalImpresionOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />

          <DialogContent sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <Box
              sx={{
                width: "210mm",
                minHeight: "297mm",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.5)",
                overflow: "hidden",
              }}
            >
              {/* Componente Referenciado para Impresión */}
              <div ref={componentRef}>
                <ReporteComprobanteCobro detalleCobro={detalleCobro} ciaNombre={ciaNombreActual} />
              </div>
            </Box>
          </DialogContent>

          <DialogActions sx={{ backgroundColor: "white", p: 2 }}>
            <Button onClick={() => setModalImpresionOpen(false)} color="inherit" sx={{ fontWeight: "bold" }}>
              Cancelar
            </Button>
            <Button
              onClick={handlePrintAction}
              variant="contained"
              color="primary"
              startIcon={<PrintIcon />}
              sx={{ px: 4, fontWeight: "bold" }}
            >
              Confirmar Impresión
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  )
}

export default CobrosDetalleIndex
